import { createAction } from "@reduxjs/toolkit";
import { TransportCategory } from "@ots-frontend/ots-data";

export const setAppDate = createAction<number>("ui/setAppDate");
export const setAppCategory = createAction<TransportCategory>("ui/setAppCategory");
